import Immutable from 'immutable';
import {
  CLEAR_ITINERARY_CLOSURE,
  FLAG_ITINERARY_CLOSURE_ACTIVITY,
  GET_ITINERARY_CLOSURE,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_ITINERARY_CLOSURE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_CLOSURE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));

    case CLEAR_ITINERARY_CLOSURE:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
